import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { EMPTY, Observable, of, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class PreloadingStrategyService implements PreloadingStrategy {
  private readonly _platformId = inject(PLATFORM_ID);

  loading = new Set<Route>();

  public preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (isPlatformBrowser(this._platformId)) {
      if (this.loading.has(route)) {
        return EMPTY;
      }

      const loadRoute = (delay: number) => delay
        ? timer(150).pipe(switchMap(() => load()))
        : load();

      if (route.data?.preload) {
        this.loading.add(route);
        return loadRoute(route.data.delay);
      }
    }

    return of(null);
  }
}
